import Vue from 'vue'
import Vuetify from 'vuetify'
import App from './App.vue'
import router from './router'
import 'vuetify/dist/vuetify.min.css'
import axios from 'axios';
import { library } from '@fortawesome/fontawesome-svg-core'
import {faUserSecret, faPen, faTrash, faScroll, faCircleInfo, faTimes, faMaximize, faGear} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { passiveSupport } from 'passive-events-support/src/utils'
passiveSupport({
    debug: false,
    events: [
        "touchstart"
    ]
})


library.add(faCircleInfo, faUserSecret, faPen, faTrash, faScroll, faTimes, faMaximize, faGear)

Vue.component('font-awesome-icon', FontAwesomeIcon)

var MobileDetect = require('mobile-detect'),
    md = new MobileDetect(window.navigator.userAgent);

Vue.use(Vuetify);
Vue.config.productionTip = false;
Vue.config.warnHandler = function (msg, vm, trace) {
};

export var store = new Vue({
    data: {
        selectedVessel: '',
        userLogged: false,
        userProfile: {},
        engineAggr: {},
        subSystemAggr: {},
        companyAggr: {},
        vesselTickets: {},
        rules: {},
        selectedTicketsVessel: '',
        type: '',
        logout_msg: '',
        loading:false,
        config: '',
        requestedBeforeLogin:''
    },
    methods: {
        is_mobile: function () {
            return md.mobile() != null;
        },
        fetch_config: async function () {
            this.config = JSON.stringify(localStorage.key('config'));
            axios.get('/config.json').then(async (response) => {
                await localStorage.setItem('config', JSON.stringify(response.data));
                this.config = response.data;

                if (this.is_mobile()) {
                    window.location.href = this.config.redirect_to + "/login";
                } else {
                    this.MyEvent.fire('config_loaded');
                }
            });
        },
        logged_in: function () {
            this.fetch_config();
        },
        getUsername: function () {
            return `${this.userProfile.firstname} ${this.userProfile.lastname}`;
        }
    },
    created() {
        this.fetch_config();

        this.MyEvent = new class {
            constructor() {
                this.vue = new Vue();
            }

            fire(event, data = null) {
                this.vue.$emit(event, data, {"passive": true});
            }

            listen(event, callback) {
                this.vue.$on(event, callback);
            }
        };

        this.MyEvent.listen('logged_in', () => {
            this.logged_in()
        });
    }
});

export var vesselStore = new Vue({
    data: {
        selectedVessel: '',
        allowNav: true,
        userLogged: false,
        userProfile: {},
        signals: {},
        reference: {},
        mapping: {},
        units: {},
        loadDiagram: {},
        limits: {},
        type: '',
        faults: [],
        dashboard: {},
        mapData: [],
        mapDate: '',
        alertFilters: [],
        alerts: [],
        validDate: false,
        checkedDate: false
    },
    created() {
    }
});

// export default new Vuetify({
//     icons: {
//         iconfont: 'fa4',
//     },
// })


new Vue({
    render: h => h(App),
    router
}).$mount('#app');
